import { Sparkles } from 'lucide-react';
import CompanyLogo from '../../../CompanyLogo/CompanyLogo';
import { useAiSearchProfilePopoutContext } from '../../AiSearchProfilePopoutContext';
import SimpleTextFormatter from '../SimpleTextFormatter';
import ProfileExperience from './ProfileExperience';
import UIStrings from '@/Utils/UIStrings';

const ProfileTimeline = () => {
    const { selectedProfile } = useAiSearchProfilePopoutContext();
    const hasExperience = !!selectedProfile?.experience?.length;
    const hasEducation = !!selectedProfile?.education?.length;
    const hasLanguages = !!selectedProfile?.languages?.length;
    const showAbout = !!selectedProfile?.about?.trim();

    return (
        <div className="flex flex-1 flex-col gap-10">
            {showAbout && (
                <div className="bg-primary/10 space-y-2 rounded-lg p-3">
                    <div className="flex flex-row items-center gap-2.5">
                        <Sparkles className="text-primary size-5 shrink-0" aria-hidden />
                        <h3 className="text-lg font-semibold tracking-tight">{UIStrings.ProfileDescription}</h3>
                    </div>
                    <SimpleTextFormatter value={selectedProfile!.about!} />
                </div>
            )}
            {hasExperience && (
                <div className="flex flex-col gap-4">
                    <h4 className="text-base font-semibold tracking-tight">{UIStrings.Experience}</h4>
                    {selectedProfile.experience!.map((experience) => (
                        <ProfileExperience
                            key={`${experience.company}${experience.startDate}${experience.endDate}`}
                            experience={experience}
                        />
                    ))}
                </div>
            )}
            {hasEducation && (
                <div className="flex flex-col gap-4">
                    <h4 className="text-base font-semibold tracking-tight">{UIStrings.Education}</h4>
                    {selectedProfile.education!.map(({ instituteName, field, degree, startDate, endDate }) => (
                        <div key={`${instituteName}${startDate}${endDate}`} className="flex flex-row gap-3">
                            <CompanyLogo companyName={instituteName} size="40px" />
                            <div className="flex min-w-0 flex-col gap-0.5 text-base">
                                <p className="font-semibold tracking-tight">{instituteName}</p>
                                <p className="text-sm font-medium">{field}</p>
                                <p className="text-sm">{degree}</p>
                                <p className="text-sm">
                                    {startDate} - {endDate}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            )}
            {hasLanguages && (
                <div className="flex flex-col gap-4">
                    <h4 className="text-base font-semibold tracking-tight">{UIStrings.Languages}</h4>
                    <div className="flex flex-col gap-4">
                        {selectedProfile.languages!.map((lang) => (
                            <div key={`${lang.name ?? ''}-${lang.level}`} className="flex flex-col gap-1">
                                <p className="text-sm font-medium">{lang.name ?? ''}</p>
                                {lang.level && <p className="text-muted-foreground text-sm">{lang.level}</p>}
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default ProfileTimeline;
